'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'face-pensive';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e384';
var svgPathData = 'M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM208 392h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm143.6-88c14.6 0 30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1c10.9 19.3 26.4 27.9 41 27.9zm-233-27.9c10.9 19.3 26.4 27.9 41 27.9s30.2-8.6 41-27.9c2.2-3.9 7-5.2 10.9-3.1s5.2 7 3.1 10.9c-13.1 23.4-33.6 36.1-55 36.1s-41.8-12.7-55-36.1c-2.2-3.9-.8-8.7 3.1-10.9s8.7-.8 10.9 3.1zM80.5 218.8c-1.6-4.1 .5-8.7 4.7-10.3l20.7-7.8c26.2-9.8 48.2-28.5 62.1-52.8l9.1-15.9c2.2-3.8 7.1-5.2 10.9-3s5.2 7.1 3 10.9l-9.1 15.9c-15.7 27.5-40.6 48.7-70.3 59.9l-20.7 7.8c-4.1 1.6-8.7-.5-10.3-4.7zm346.3-10.3c4.1 1.6 6.2 6.2 4.7 10.3s-6.2 6.2-10.3 4.7l-20.7-7.8c-29.7-11.1-54.6-32.3-70.3-59.9L321.1 140c-2.2-3.8-.9-8.7 3-10.9s8.7-.9 10.9 3l9.1 15.9c13.9 24.3 35.8 43 62.1 52.8l20.7 7.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFacePensive = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;